/* import __COLOCATED_TEMPLATE__ from './project-completion-private-feedback.hbs'; */
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { EMBER_ROUTE_NAMES } from "../../constants/routes";

const NOTE_MAX_LENGTH = 255;

/**
 * This will show the private feedback section for the project completion flow
 */
export default Component.extend({
  NOTE_MAX_LENGTH,
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-project-completion-private-feedback'],

  /**
   * Register services
   */
  applicationStateManager: service('state-managers/application'),
  state: service('states/routes/project-completion'),
  stateManager: service('state-managers/routes/project-completion'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}      True if we are able to save the seller to the user's network.
   */
  _isCanSaveToNetwork: computed(
  'state.application.seller.inCurrentUsersNetwork',
  function() {
    return !this.get('state.application.seller.inCurrentUsersNetwork');
  }),

  /**
   * @type {Boolean}
   */
  _isSubmitFeedbackDisabled: computed('state.isSubmittingPrivateFeedback', function() {
    return this.get('state.isSubmittingPrivateFeedback');
  }),

  /**
   * @type {String}
   */
  _placeholderNotesForTeam: computed('state.application.seller.firstName', function() {
    return `These notes will be available to you and your team on ${this.get('state.application.seller.firstName')}’s profile page.`;
  }),

  actions: {
    onNotesForTeamChanged(text) {
      this.stateManager.setNotesForTeamMessage(text);
    },

    onNotesForGlimmerChanged(text) {
      this.stateManager.setNotesForGlimmerMessage(text);
    },

    onAddToNetworkCheckboxToggled() {
      this.stateManager.toggleAddToNetworkChecked();
    },

    /**
     *
     */
    onSkipClicked: function() {
      this.get('applicationStateManager').setNextRoute(
        EMBER_ROUTE_NAMES.PROJECT__DETAILS,
        null,
        this.get('state.application.id'));

      this.get('stateManager').initStateManager();
    },

    /**
     * @param {Number} starCountSelected
     */
    onStarClick: function(starCountSelected) {
      this.get('stateManager').updateReviewStarCountSelected(starCountSelected + 1);
    },

    /**
     *
     */
    onSubmitFeedbackClicked: function() {
      if (this.get('state.isBuyerViewing')) {
        this.get('stateManager.submitPrivateFeedbackBuyer').perform().then(() => {
          this.get('applicationStateManager').setNextRoute(
            EMBER_ROUTE_NAMES.PROJECT__DETAILS,
            null,
            this.get('state.application.id'));

          this.get('stateManager').initStateManager();
        });

        return;
      }

      this.get('stateManager.submitPrivateFeedbackSeller').perform().then(() => {
        this.get('applicationStateManager').setNextRoute(
          EMBER_ROUTE_NAMES.PROJECT__DETAILS,
          null,
          this.get('state.application.id'));

        this.get('stateManager').initStateManager();
      });
    }
  }
});
